import React from "react";
import { Typography, LinearProgress } from "@ann/web-components";
import { HeaderContainer, TopRow, LeftSection, RightSection, ProgressContainer } from "./Header.styled";

const Header = ({ currentProgress = 0 }) => {
  return (
    <HeaderContainer>
      <TopRow>
        <LeftSection>
          <Typography
            category="subtitle"
            size="medium"
            weight="bold"
          >
            Training Progress
          </Typography>
        </LeftSection>
        <RightSection>
          <Typography
            category="subtitle"
            size="medium"
            weight="bold"
          >
            {currentProgress}%
          </Typography>
        </RightSection>
      </TopRow>
      <ProgressContainer>
        <LinearProgress value={currentProgress} />
      </ProgressContainer>
      <Typography
        category="body"
        size="medium"
        weight="regular"
        color="body"
        style={{ fontSize: 'var(--Body-Regular-M, 14px)' }}
      >
        Welcome to the HR Base knowledge training session! I'm your AI training partner. Let's start with something foundational: What are the key techniques for identifying customer needs and closing deals effectively? <br /> <br />
        💡 Be specific and detailed in your answers for better AI training
      </Typography>
    </HeaderContainer>
  );
};

export default Header;
